import Header from "./components/Header";
import Hero from "./components/Hero";
import MessageSection from "./components/MessageSection";
import ServiceSection from "./components/ServiceSection";
import JournalSection from "./components/JournalSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <MessageSection />
        <ServiceSection />
        <JournalSection />
        <ContactSection />
      </main>
      <Footer />

      {/* Schema.org WebPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "訪問介護・障害福祉サービス｜株式会社FD ヘルパーステーションみりん【刈谷市】",
          "description": "愛知県刈谷市の株式会社FD・ヘルパーステーションみりん。訪問介護・障害福祉サービス（居宅介護・重度訪問介護）を提供。地域の高齢者・障害者の生活支援を行っています。",
          "url": "https://future-diver.jp/",
          "mainEntity": {
            "@type": "Organization",
            "name": "株式会社FD",
            "url": "https://future-diver.jp/"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "ホーム",
                "item": "https://future-diver.jp/"
              }
            ]
          }
        })}
      </script>
    </div>
  );
}
